import { createQueryKeys } from '@lukemorales/query-key-factory';

export const BLOCK = createQueryKeys('block', {
  list: (filter: { houseId: number }) => [filter],
  single: (blockId: number) => [blockId]
});

export const FLAT = createQueryKeys('flat', {
  list: (filter: { blockId: number }) => [filter],
  single: (flatId: number) => [flatId],
  priceChanges: (filter: { blockId: number; houseId: number }) => [filter]
});

export const ENTRANCE = createQueryKeys('entrance', {
  list: (filter: { blockId: number }) => [filter],
  single: (filter: { entranceId: number }) => [filter]
});

export const FIELD = createQueryKeys('field', { list: () => [''] });
